import { render, staticRenderFns } from "./AttachEmailDialog.vue?vue&type=template&id=dc4ebff4&scoped=true"
import script from "./AttachEmailDialog.vue?vue&type=script&lang=js"
export * from "./AttachEmailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4ebff4",
  null
  
)

export default component.exports